import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { EcoVideoItemsItemProps } from 'eco-design/sections/eco-video-items/EcoVideoItem';
// import EcoGraphicSwiper from 'eco-design/sections/eco-graphic-swiper';
import EcoVideoItems from 'eco-design/sections/eco-video-items';
const SuperchargeSectionStatusC = () => {
    const { t } = useLang('theProduct.SuperchargeSectionStatusC');

    // const list = [
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1751868321882/supercharge-your-solar-section_img1.jpg',
    //         title: t('card1'),
    //         desc: t('card1Desc'),
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1751868788051/supercharge-your-solar-section_img2.jpg',
    //         title: t('card2'),
    //         desc: t('card2Desc'),
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1751868322423/supercharge-your-solar-section_img3.jpg',
    //         title: t('card3'),
    //         desc: t('card3Desc'),
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1751868322283/supercharge-your-solar-section_img4.jpg',
    //         title: t('card4'),
    //         desc: t('card4Desc'),
    //     },
    // ];
    const itemsA: EcoVideoItemsItemProps[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751868321882/supercharge-your-solar-section_img1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751868321882/supercharge-your-solar-section_img1.jpg',
            title: t('card1'),
            useName1: t('card1Desc'),
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1751876765479/KSP1-PC.mp4',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751868788051/supercharge-your-solar-section_img2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751868788051/supercharge-your-solar-section_img2.jpg',
            title: t('card2'),
            useName1: t('card2Desc'),
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1751876788044/KSP2-PC.mp4',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751868322423/supercharge-your-solar-section_img3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751868322423/supercharge-your-solar-section_img3.jpg',
            title: t('card3'),
            useName1: t('card3Desc'),
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1751876807039/KSP3-PC.mp4',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751868322283/supercharge-your-solar-section_img4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751868322283/supercharge-your-solar-section_img4.jpg',
            title: t('card4'),
            useName1: t('card4Desc'),
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1752218790424/KSP4-PC.mp4',
        },
    ];
    return (
        <section className={styles.SuperchargeSectionStatusC}>
            <div className="text-container">
                <p className="label">{t('label')}</p>
                <h2 className="title">{t('title')}</h2>
                <p className="intro">{t('desc')}</p>
            </div>
            <EcoVideoItems items={itemsA} />
            {/* <EcoGraphicSwiper uiType="ui4" imgHeight="5-3" items={list} /> */}
            <div
                className="btn-container"
                onClick={() => {
                    window.open('https://www.ecoflow.com/us/ocean-pro-home-solar-battery', '_self');
                }}
            >
                <button className="primary-btn">{t(`btn`)}</button>
            </div>
        </section>
    );
};

export default SuperchargeSectionStatusC;
